import { render, staticRenderFns } from "./ModuleSelection.vue?vue&type=template&id=1d7bdc45&scoped=true"
import script from "./ModuleSelection.vue?vue&type=script&lang=js"
export * from "./ModuleSelection.vue?vue&type=script&lang=js"
import style0 from "./ModuleSelection.vue?vue&type=style&index=0&id=1d7bdc45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bdc45",
  null
  
)

export default component.exports